(()=> {
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let dispose=()=>{};
function init(){
dispose();
const abort=new AbortController(), signal=abort.signal;
const header=document.querySelector('.site-header'), logo=header?.querySelector('.logo');
const hero=document.querySelector('.hero');
let frame=0;
document.body.classList.remove('fvm-motion-home');
if(logo){['transform','width','margin-left','top'].forEach(p=>logo.style.removeProperty(p));}
if(hero&&logo&&!reduced.matches){
document.body.classList.add('fvm-motion-home');
let bounds,heroTop,heroHeight,baseTop;
function measure(){
document.body.classList.remove('fvm-motion-home');
['transform','width','margin-left','top'].forEach(p=>logo.style.removeProperty(p));
bounds=logo.getBoundingClientRect();
baseTop=bounds.top-header.getBoundingClientRect().top;
header.style.setProperty('--fvm-row-height',header.querySelector('.header-row').offsetHeight+'px');
document.body.classList.add('fvm-motion-home');
heroTop=hero.getBoundingClientRect().top+scrollY;
heroHeight=hero.offsetHeight;
update();
}
function update(){
frame=0;
const range=Math.max(140,Math.min(320,heroHeight*.55));
const p=Math.min(1,Math.max(0,scrollY/range));
const remaining=1-p;
const scale=Math.max(1,Math.min(4,(innerWidth*.65)/bounds.width));

const y=Math.max(0,heroTop+heroHeight*.417-(bounds.height*scale)/2-bounds.top);
const width=Math.round(bounds.width*(1+(scale-1)*remaining));
logo.style.width=width+'px';
logo.style.marginLeft=-(width/2)+'px';
logo.style.top=Math.round(baseTop+y*remaining)+'px';
header.style.setProperty('--fvm-header-alpha',String(.86*p));
}
function schedule(){if(!frame)frame=requestAnimationFrame(update)}
measure();
addEventListener('scroll',schedule,{passive:true,signal});
addEventListener('resize',measure,{signal});
document.fonts.ready.then(()=>{if(!signal.aborted)measure()});
logo.querySelector('img')?.addEventListener('load',measure,{signal});
}

dispose=()=>{abort.abort();cancelAnimationFrame(frame);};
}
init();
document.addEventListener('shopify:section:load',init);
reduced.addEventListener('change',init);
})();
(()=> {
if(!document.querySelector('.hero'))return;
let interacted=false;
let scrollFrame=0;
const stopScroll=()=>{cancelAnimationFrame(scrollFrame);scrollFrame=0;};
['wheel','touchstart','pointerdown'].forEach(type=>addEventListener(type,stopScroll,{passive:true}));
addEventListener('keydown',event=>{if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' ','Escape'].includes(event.key))stopScroll();});

const markInteraction=()=>{interacted=true;};
['pointerdown','touchstart','wheel','keydown'].forEach(type=>addEventListener(type,markInteraction,{passive:true,once:true}));
if(!location.hash||location.hash==='#catalogo'){
history.scrollRestoration='manual';
if(location.hash==='#catalogo')history.replaceState(history.state,'',location.pathname+location.search);
const showCover=()=>{if(!interacted)scrollTo({top:0,left:0,behavior:'instant'});};
showCover();
addEventListener('pageshow',event=>{if(!event.persisted)showCover();},{once:true});
}
document.addEventListener('click',event=>{
const link=event.target.closest('.hero .btn');
if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
const url=new URL(link.href,location.href);
if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
const target=document.getElementById(decodeURIComponent(url.hash.slice(1)));
if(!target)return;
event.preventDefault();
interacted=true;
const headerHeight=document.querySelector('.site-header .header-row')?.offsetHeight||0;
stopScroll();
const destination=Math.min(Math.max(0,document.documentElement.scrollHeight-innerHeight),Math.max(0,target.getBoundingClientRect().top+scrollY-headerHeight));
if(matchMedia('(prefers-reduced-motion: reduce)').matches){scrollTo({top:destination,behavior:'instant'});return;}
const startY=scrollY;
const startTime=performance.now();
const duration=800;
function animate(now){
const progress=Math.min(1,Math.max(0,(now-startTime)/duration));
const eased=(1-Math.cos(Math.PI*progress))/2;
scrollTo({top:startY+(destination-startY)*eased,behavior:'instant'});
if(progress<1)scrollFrame=requestAnimationFrame(animate);
else scrollFrame=0;
}
scrollFrame=requestAnimationFrame(animate);
});
})();
